module.exports = __webpack_public_path__ + "static/media/13_tearsofhair.5035ca43.jpg";